import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'
import { rhythm, media, color } from '../utils/typography'
import classnames from 'classnames'

import Container from './container'
import Link from './link'
import HeaderLink from './header-link'
import LanguageSwitcher from './language-switcher'
import Image from './image'

export default styled(withTranslation()(({ className, t, root }) => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "logo-black.png" }) {
        childImageSharp {
          fluid(maxHeight: 300) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <header className={classnames({root, [className]: true})}>
      <Container className='container'>
        <section className='brand'>
          {root
            ? <Image className='logo' objectFit='scale-down' fluid={data.logo.childImageSharp.fluid} />
            : <Link className='logo-link' to='/'>
                <Image className='logo' objectFit='scale-down' fluid={data.logo.childImageSharp.fluid} />
                <span className='logo-brand'>{t('ipac.name')}</span>
              </Link>}

          <h1 className='brand-name'>
            <span>{t('ipac.name')}</span>
            <span>對華政策跨國議會聯盟</span>
            <span>对华政策跨国议会联盟</span>
            <span>対中政策に関する列国議会連盟</span>
          </h1>
        </section>

        <ul className='inline-list links'>
          <li><HeaderLink to='/about' root={root}>{t('about.title')}</HeaderLink></li>
          <li><HeaderLink to='/statement' root={root}>{t('statement.title')}</HeaderLink></li>
          <li><HeaderLink to='/campaigns' root={root}>{t('campaigns.title')}</HeaderLink></li>
          <li><HeaderLink to='/team' root={root}>{t('members.title')}</HeaderLink></li>
          {/*<li><HeaderLink to='/resources' root={root}>{t('resources.title')}</HeaderLink></li>*/}
          <li><HeaderLink to='/news' root={root}>{t('articles.title')}</HeaderLink></li>
          <li><HeaderLink to='/contact' root={root}>{t('contact.title')}</HeaderLink></li>
          {/*!root ?
            <li><LanguageSwitcher className='language-switcher' /></li>
          : null*/}
        </ul>

        {/*root ?
          <LanguageSwitcher className='language-switcher' />
        : null*/}
      </Container>
    </header>
  )
}))`
  &, .container { height: 3em; }
  &.root, &.root .container { min-height: 100vh }

  a, a:hover, a:active { color: ${color.body} }
  &.root a {
    color: ${color.accent};
    &:hover, &:active {
      color: ${color.body};
    }
  }

  border-bottom: 1px solid ${color.header};
  margin-bottom: ${rhythm(1/2)};
  &.root {
    border-bottom: 0;
    margin-bottom: 0;
  }

  .container {
    position: relative;
    display: flex;
    align-items: center;
    justify-items: center;
    justify-content: space-between;
  }
  &.root .container {
    justify-content: center;
    padding: 0;
  }

  .logo-link {
    display: flex;
    justify-content: start;
    align-items: center;
  }

  .logo {
    display: block;
    ${media.tablet} { display: block; }
    height: 1.5em;
    width: 1.5em;
    ${media.tablet} { margin-right: ${rhythm(1/4)}; }
  }
  &.root .logo {
    display: block;
    height: 100px;
    width: auto;
    margin-right: 0;
    ${media.tablet} { height: 200px }
  }

  .brand {
    width: 100%;
    ${media.tablet} { width: auto }
  }
  .logo-brand {
    display: inline-block;
    text-align: center;
    width: 100%;
    ${media.tablet} { width: auto }
  }

  .brand-name { display: none }
  &.root .brand-name {
    display: block;
    width: 100%;
    text-align: center;

    span {
      display: block;
      margin: ${rhythm(1/4)};
      ${media.tablet} { margin: ${rhythm(1/3)} }
      ${media.desktop} { margin: ${rhythm(1/2)} }
    }
  }

  .language-switcher {
    display: none;
    ${media.desktop} { display: block; }
    margin: 0;
    color: ${color.header};
    padding: 0;
  }

  &.root .language-switcher {
    display: block;
    position: absolute;
    top: ${rhythm(1)};
    right: ${rhythm(1)};
    color: ${color.accent};
    padding: ${rhythm(1/6)} 0;
  }

  .links {
    display: none;
    ${media.tablet} { display: block; }
    a { cursor: pointer; }
  }

  &.root .links {
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    margin: 0 0 ${rhythm(1)};
    padding: 0 ${rhythm(1)};
    align-self: center;
    justify-self: end;
  }

  .links {
    text-align: center;

    li {
      text-transform: lowercase;
      margin: 0 ${rhythm(1/4)};
    }
  }

  &.root .links li { margin: 0 ${rhythm(1/2)} }
`
